import { BrowserRouter } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.css';
import "assets/fonts/survey-icons/style.css";
import "assets/css/main.css";
import {Provider} from "react-redux";
import {PersistGate} from "redux-persist/integration/react";
import store, { persistor } from './store'
import Layout from "./components/layout";
import history from './history'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


function App() {
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <BrowserRouter history={history}>
                    <div lang='az'>
                        <Layout />
                        <ToastContainer />
                    </div>
                </BrowserRouter>
            </PersistGate>
        </Provider>
    );
}

export default App;
